export default "__VITE_ASSET__h5fVD80w__"